import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import clsx from 'clsx';
import React, { useState } from 'react';
import { AlignmentTypes } from "../../types/Tooltip";
import { createStyles } from "./styles";

var Tooltip = function Tooltip(props) {
  var classes = createStyles(props);
  var className = props.className,label = props.label,_props$alignment = props.alignment,alignment = _props$alignment === void 0 ? AlignmentTypes.BOTTOM_START : _props$alignment,children = props.children;
  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),visible = _useState2[0],setVisible = _useState2[1];

  var showTooltip = function showTooltip() {
    setVisible(true);
  };

  var hideTooltip = function hideTooltip() {
    setVisible(false);
  };

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.tooltipWrapper, onMouseEnter: showTooltip, onMouseLeave: hideTooltip },
    children,
    visible && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("div", {
      className: clsx(
      classes.tooltip,
      classes[classes[alignment] ? alignment : AlignmentTypes.BOTTOM_START],
      className) },


    label))));





};

export default Tooltip;
//# sourceMappingURL=index.js.map